module.exports = __webpack_public_path__ + "static/media/S40_black.de0f854b.png";